import React from 'react';
import { Button } from 'antd';
import { useLocation } from '@reach/router';

import styles from './BackToHomeButton.module.scss';

const BackToHomeButton = () => {
  const location = useLocation();

  return (
    <Button className={styles.self} type="link" href={location.pathname} size="large">
      Zamów kolejną intencję
    </Button>
  );
};

BackToHomeButton.propTypes = {};

export default BackToHomeButton;
